export default {
	common: {
		clearSelection: "Clear selection",
		delete: "Delete",
		close: "Close",
	},
	catalogue: {
		pendingOrdersTitle: "Pending orders",
		pendingOrdersDescription:
			"The following orders have been requested by the respective users but have not yet been approved.",
		uploadButtonTooltip: "Select and upload articles.",
		importTitle: "Article import",
		importHint: "Drag up to 10 files (.step / .stp / .dxf) into this area or click the button",
		emptyHint: "Still a bit empty here...",
		importInstructions:
			"Import your CAD models in .step or .dxf format by dragging the files onto this area, or click the button above to select the files.",
		importProcessDescription:
			"Blexon then imports your parts, checks them for feasibility and automatically calculates the prices.",
		videoIntro: "The video shows the first steps with Blexon",
		videoTitle:
			"This is how easily you can upload CAD models to Blexon and order laser-cut sheet metal parts made to measure directly online",
		searchLabel: "Search articles:",
		searchPlaceholder: "Enter article name or number...",
		sortingLabel: "Sorting:",
		userFilterLabel: "Show articles from:",
		loadMoreTooltip: "Loads more articles with the current filter settings.",
		loadMoreButton: "Load more",
		sortTypes: {
			createdDescending: "Newest created first",
			createdAscending: "Newest created last",
			lastChangeDescending: "Last changed first",
			lastChangeAscending: "Last changed last",
			nameAscending: "By article name A - Z",
			nameDescending: "By article name Z - A",
			materialNameAscending: "By material name A - Z",
			materialNameDescending: "By material name Z - A",
			materialThicknessAscending: "By material thickness (thin first)",
			materialThicknessDescending: "By material thickness (thick first)",
		},
		uploadWarningDialog: {
			title: "Incompatible files",
			invalidFormatText: "The following files have an invalid format and cannot be uploaded:",
			errorText:
				"The following files exceed the maximum allowed file size and cannot be uploaded:",
			warningText: "The following files are very large and will not be processed automatically:",
			warningHint:
				"Please define the appropriate material and correct thickness for these articles. After blexonising, the articles will be added to your catalogue. From there you can send the articles to our helpdesk for review.",
			moreInfo:
				"You can find more information on the permitted file sizes and the causes of large CAD models in our {blog}.",
			blogLinkText: "blog",
		},
		messages: {
			maxFilesExceeded: "You can upload a maximum of 10 CAD models at once.",
		},
	},
	assembly: {
		processing: "Assembly is being processed...",
		back: "Back",
		title: "Assembly: {articleId} | '{articleName}'",
		multiDeleteDialog: {
			title: "Delete multiple articles",
			deleting: "Articles are being deleted...",
			invalidStateText:
				"The following articles are either locked or currently being calculated and can therefore {not} be deleted:",
			notWord: "not",
			confirmText: "Do you really want to delete {count} article(s)?",
			noneDeletable: "None of the selected articles can be deleted.",
			deleteButton: "Delete",
		},
		messages: {
			deleteError: "Error deleting an article.",
		},
	},
	multiedit: {
		deleteButton: "Delete {count} article(s)",
		powderCoatButton: "Powder coat {count} article(s)",
		powderCoatTooltip: "Add, edit or remove powder coating for all selected articles.",
		zincCoatButton: "Zinc coat {count} article(s)",
		zincCoatTooltip: "Add, edit or remove zinc coating for all selected articles.",
	},
	multieditAssembly: {
		deleteButton: "Delete {count} article(s)",
	},
	importArticle: {
		uploading: "Uploading...",
		articleNameLabel: "Article name",
		articleNumberLabel: "Article number (optional)",
		articleNumberPlaceholder: "Your article number",
		quantityInAssembly: "{count} piece(s)",
		thickness: "Thickness: {thickness}mm",
		noMaterialFoundHintMain:
			"We could not find a material matching the detected thickness. Please select the desired material from the list and blexonise the article. If an error occurs, you can send the article to our helpdesk for review.",
		noMaterialFoundHintSubArticle:
			'We could not find a material matching the detected thickness. We recommend deleting press-fit inserts using the "bin" icon on the right and then defining them in the CAD viewer. You can also remove "non-sheet-metal parts" this way before processing.',
		materialPlaceholder: "Please select a material...",
		thicknessPlaceholder: "Please select a thickness...",
		pressJoinPlaceholder: "... or select a press-fit insert",
		noPressJoinsAvailable: "No press-fit inserts available",
		deleteTooltip: "Cancels the import process and removes the article from the list.",
		deleteSubArticleTooltip: "Remove this solid body from the model.",
		blexonisierenButton: "Blexonise",
		blexonisierenTooltip:
			"Analyses the article and automatically detects machining operations. Price calculation starts.",
		pressJoinCategories: {
			selfClinchingNuts: "Self-clinching nuts",
			selfClinchingThreadedStud: "Self-clinching threaded studs",
			selfClinchingThreadedStandoff: "Self-clinching threaded standoffs",
		},
		messages: {
			deleteError: "The article could not be deleted.",
		},
	},
	importAssembly: {
		articleNameLabel: "Article name",
		articleNumberLabel: "Article number (optional)",
		articleNumberPlaceholder: "Your article number",
		assemblyProcessingText: "Oh, an assembly. Let's break that down...",
		materialPlaceholderAvailable: "Please select a material...",
		materialPlaceholderUnavailable: "No common material available for all parts",
		materialHint:
			"This material is not available for all parts. Please select the missing materials individually below.",
		deleteTooltip: "Cancels the import process and removes the article from the list.",
		blexonisierenButton: "Blexonise",
		blexonisierenTooltip:
			"Analyses the assembly and automatically detects machining operations. Price calculation starts.",
		messages: {
			deleteError: "The article could not be deleted.",
		},
	},
	pendingOrder: {
		summary: "Pending order from {date} by {firstname} {lastname} ({count} position(s))",
		addToCartTooltip: "Adds the order to the shopping cart.",
		addToCartButton: "Add to cart",
		deleteTooltip: "Deletes the order.",
		deleteDialog: {
			title: "Are you sure?",
			text: "Should the order from {firstname} {lastname} with {count} position(s) be deleted? This action cannot be undone.",
		},
	},
};
